import {
  ADMIN_CREATE_ROLES,
  ADMIN_ROLES,
  SUBSCRIPTION_ADMIN_ROLES,
} from './adminRoles';

const HR_PM_AC = ['Hr', 'ProjectManager', 'AdminController'];
const HR_PM_AC_DIST = [...HR_PM_AC, 'Distributor'];
const HR_PM = ['Hr', 'ProjectManager'];
const HR_AC = ['AdminController', 'Hr'];
const HR_ONLY = ['Hr'];

/** Exact path → allowed roles. Unlisted admin paths are denied by default. */
export const ROUTE_ACCESS = {
  '/admin-dashboard': ADMIN_ROLES,
  '/control-hub': ADMIN_ROLES,
  '/home': ADMIN_ROLES,
  '/profile': ADMIN_ROLES,
  '/tutorial': ADMIN_ROLES,

  '/create-user': HR_PM_AC,
  '/create-admin': ADMIN_CREATE_ROLES,
  '/admin-setup-guide': HR_AC,
  '/CacheSettings': HR_PM_AC,

  '/subscription-analysis': HR_PM_AC,
  '/Payments': HR_PM_AC,
  '/payment-statistics': HR_PM_AC,
  '/refund-activity': HR_PM_AC,
  '/admin-time-pools': HR_PM_AC,
  '/addon-plans': HR_PM_AC,

  '/users-list': HR_PM_AC,
  '/update-user': HR_PM_AC,
  '/admin-user': HR_PM,
  '/robot-form': HR_PM_AC,
  '/user-robot': HR_PM_AC,
  '/RobotMsgList': HR_PM_AC,
  '/Robot-Booking': HR_PM_AC,
  '/Booking-details': HR_PM_AC,
  '/update-apppermession': HR_PM_AC,

  '/card-global': HR_PM_AC,
  '/update-Version': HR_PM_AC,
  '/metadata-Change': HR_PM_AC,
  '/disinfectionTime': HR_PM_AC,
  '/Viewimage': HR_PM_AC,

  '/DataFormCard': HR_PM_AC_DIST,
  '/Hospital': HR_PM_AC_DIST,
  '/ScanningCenter': HR_PM_AC_DIST,
  '/CelebrityHomeForm': HR_PM_AC_DIST,
  '/MallDataForm': HR_PM_AC_DIST,
  '/StarHotel': HR_PM_AC_DIST,

  '/dataviewcard': HR_PM_AC_DIST,
  '/Viewhospital': HR_PM_AC_DIST,
  '/Viewscanningcenter': HR_PM_AC_DIST,
  '/CelebrityHome': HR_PM_AC_DIST,
  '/Malldetails': HR_PM_AC_DIST,
  '/Hoteldata': HR_PM_AC_DIST,

  '/Employeecard': HR_PM_AC,
  '/TicketForm': HR_PM_AC,
  '/EmployeeList': HR_PM_AC,
  '/employee-data/all': HR_ONLY,
  '/SOP': HR_PM_AC_DIST,
  '/SOP-POST': HR_PM_AC_DIST,
  '/EmployeeDateRange': HR_ONLY,

  '/LeaveCard': HR_PM_AC,
  '/Applyleave': HR_PM_AC,
  '/Getleavedata': HR_PM,
  '/LeaveStatus': HR_PM_AC,

  '/dar-List': HR_PM_AC,
  '/DarDistributor': HR_PM_AC,
  '/DarQuestion-uplode': HR_PM_AC,
  '/Update-DarQuestions': HR_PM_AC,
  '/Take-DarAnalysis': HR_PM_AC_DIST,
  '/Dar-Potentiallevel': HR_PM_AC_DIST,
  '/DarAnswer-value': HR_PM_AC,
  '/DarFullAnswer': HR_PM_AC,

  '/security': HR_PM_AC,
  '/disinfection-analysis': HR_PM_AC,
  '/analytics/robots-list': HR_PM_AC,
};

/** Prefix patterns for dynamic segments (evaluated after exact match). */
const ROUTE_PREFIX_ACCESS = [
  { prefix: '/user-payments/', roles: HR_PM_AC },
  { prefix: '/user-details/', roles: HR_PM_AC },
  { prefix: '/robots/', roles: HR_PM_AC },
  { prefix: '/robot/', roles: HR_PM_AC },
  { prefix: '/camera-images/', roles: HR_PM_AC },
  { prefix: '/sessions/', roles: HR_PM_AC },
  { prefix: '/appdetails/', roles: HR_PM_AC },
  { prefix: '/analytics/robot/', roles: HR_PM_AC },
  { prefix: '/admin-subscriptions', roles: SUBSCRIPTION_ADMIN_ROLES },
  { prefix: '/invoice', roles: SUBSCRIPTION_ADMIN_ROLES },
  { prefix: '/admin/users', roles: HR_AC },
];

export function getAllowedRolesForPath(pathname) {
  const path = pathname.split('?')[0];
  if (ROUTE_ACCESS[path]) {
    return ROUTE_ACCESS[path];
  }
  for (const { prefix, roles } of ROUTE_PREFIX_ACCESS) {
    if (path.startsWith(prefix)) {
      return roles;
    }
  }
  return null;
}

export function isAdminPath(pathname) {
  const path = pathname.split('?')[0];
  if (path === '/login') return false;
  if (path.startsWith('/client')) return false;
  if (path.startsWith('/user-app')) return false;
  if (path.startsWith('/user/subscription')) return false;
  return true;
}
